<template>
  <v-dialog v-model="showDialog" max-width="650" persistent>
    <v-card>
      <ModalHeader
        title="Edit Warranty Policy"
        icon="mdi-shield-check"
        @close="showDialog = false"
      />
      <v-card-text class="pa-4">
        <v-text-field
          outlined
          dense
          v-model="policy.name"
          label="Policy Name"
          prepend-icon="mdi-shield-check"
        ></v-text-field>
        <v-textarea
          outlined
          dense
          v-model="policy.description"
          label="Description"
          prepend-icon="mdi-text"
          rows="2"
          auto-grow
        ></v-textarea>

        <v-select
          outlined
          dense
          v-model="policy.warranty_type"
          :items="warrantyTypeOptions"
          label="Warranty Type"
          prepend-icon="mdi-tag"
          hint="Determines which warranty terms are printed on the certificate"
          persistent-hint
        ></v-select>

        <v-divider class="my-3"></v-divider>
        <p class="subtitle-2 grey--text">Warranty Durations</p>

        <v-row dense>
          <v-col cols="6">
            <v-text-field
              outlined
              dense
              v-model.number="policy.major_parts_warranty_value"
              label="Major Parts Warranty"
              type="number"
              min="0"
              prepend-icon="mdi-cog"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-select
              outlined
              dense
              v-model="policy.major_parts_warranty_unit"
              :items="unitOptions"
              label="Unit"
            ></v-select>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="6">
            <v-text-field
              outlined
              dense
              v-model.number="policy.minor_parts_warranty_value"
              label="Minor Parts Warranty"
              type="number"
              min="0"
              prepend-icon="mdi-cog-outline"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-select
              outlined
              dense
              v-model="policy.minor_parts_warranty_unit"
              :items="unitOptions"
              label="Unit"
            ></v-select>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="6">
            <v-text-field
              outlined
              dense
              v-model.number="policy.service_warranty_value"
              label="Service Warranty"
              type="number"
              min="0"
              prepend-icon="mdi-wrench"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-select
              outlined
              dense
              v-model="policy.service_warranty_unit"
              :items="unitOptions"
              label="Unit"
            ></v-select>
          </v-col>
        </v-row>

        <v-divider class="my-3"></v-divider>
        <p class="subtitle-2 grey--text">Chip Color</p>
        <div class="d-flex flex-wrap" style="gap: 8px">
          <v-chip
            v-for="c in colorOptions"
            :key="c.value"
            :color="c.value"
            dark
            small
            :outlined="policy.color !== c.value"
            @click="policy.color = c.value"
            class="cursor-pointer"
            >{{ c.text }}</v-chip
          >
        </div>

        <v-switch
          v-model="policy.is_active"
          label="Active"
          color="green"
        ></v-switch>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="showDialog = false">Cancel</v-btn>
        <v-btn color="primary" :loading="loading" @click="submit">
          Update
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["show", "policy"],
  computed: {
    showDialog: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
  },
  data() {
    return {
      loading: false,
      warrantyTypeOptions: [
        { text: "Regular (Per-Item Warranty)", value: "regular" },
        { text: "Desktop PC Sets", value: "desktop" },
        { text: "Laptop", value: "laptop" },
        { text: "CCTV Systems", value: "cctv" },
        { text: "Repairs & Replacements", value: "repairs" },
        { text: "Printer", value: "printer" },
      ],
      colorOptions: [
        { text: "Blue", value: "blue" },
        { text: "Teal", value: "teal" },
        { text: "Purple", value: "purple" },
        { text: "Indigo", value: "indigo" },
        { text: "Cyan", value: "cyan" },
        { text: "Green", value: "green" },
        { text: "Orange", value: "orange" },
        { text: "Red", value: "red" },
        { text: "Pink", value: "pink" },
        { text: "Brown", value: "brown" },
        { text: "Blue Grey", value: "blue-grey" },
        { text: "Deep Purple", value: "deep-purple" },
      ],
      unitOptions: [
        { text: "Days", value: "days" },
        { text: "Months", value: "months" },
        { text: "Years", value: "years" },
      ],
    };
  },
  methods: {
    ...mapActions({
      edit_warranty_policy: "warranty_policy/edit_warranty_policy",
    }),
    async submit() {
      if (!this.policy.name) return;
      this.loading = true;
      try {
        await this.edit_warranty_policy(this.policy);
        this.showDialog = false;
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },
  },
};
</script>
